import { defineStore } from 'pinia';
import { BusinessState, IEditBomData } from './types';

const useBusinessStore = defineStore('business', {
  state: (): BusinessState => ({
    production: {
      refreshOrder: false, // 刷新生产单
      refreshGoodsId: undefined, // 根据goodsId刷新生产单商品
      editBomData: new Map(), // 修改生产单物料bom清单用到的数据
      isCopy: false, // 记录本次跳转修改bom是否是复制生产单页面,
      isPlanToProduce: false, // 记录本次跳转修改bom是否是计划单/请求单新增生产单页面
      showEmptyNumberMaterial:
        localStorage.getItem('PRODUCE_SHOW_EMPTY_NUMBER') === 'true',
      enableEditProdNumber: false, // 是否启用编辑生产单数量
      enableEditProdMaterialBom: false, // 是否启用编辑生产单物料bom
    },
    purchase: {
      refreshMaterialDemand: false, // 刷新生产单
    },
    designOrder: {
      refreshOrder: false, // 刷新版单
    },
  }),

  getters: {},

  actions: {
    setEnableEditProdNumber(data?: boolean) {
      this.production.enableEditProdNumber = data ?? false;
    },
    setEnableEditProdMaterialBom(data?: boolean) {
      this.production.enableEditProdMaterialBom = data ?? false;
    },
    setShowEmptyNumberMaterial(data?: boolean) {
      this.production.showEmptyNumberMaterial = data ?? false;
    },
    setRefreshOrder(data?: boolean) {
      this.production.refreshOrder = data ?? false;
    },
    setRefreshMaterialDemand(data?: boolean) {
      this.purchase.refreshMaterialDemand = data ?? false;
    },
    setRefreshGoodsId(data?: any) {
      this.production.refreshGoodsId = data;
    },
    setEditBomData(ordersSn: string, data?: IEditBomData) {
      if (data) {
        this.production.editBomData.set(ordersSn, data);
      } else {
        this.production.editBomData.delete(ordersSn);
      }
    },
    getEditBomData(ordersSn: string) {
      return this.production.editBomData.get(ordersSn);
    },
    setIsCopyProduction(copy?: boolean) {
      this.production.isCopy = copy ?? false;
    },
    setIsPlanToProduce(isPlanToProduce?: boolean) {
      this.production.isPlanToProduce = isPlanToProduce ?? false;
    },
    setRefreshDesignOrder(data?: boolean) {
      this.designOrder.refreshOrder = data ?? false;
    },
  },
});

export default useBusinessStore;
